'use client';
'use strict';

var dayjs = require('dayjs');
var timezonePlugin = require('dayjs/plugin/timezone.js');
var utcPlugin = require('dayjs/plugin/utc.js');

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
function getTimezoneOffset(date, timezone) {
  if (timezone) {
    return dayjs(date).tz(timezone).utcOffset() + date.getTimezoneOffset();
  }
  return 0;
}

exports.getTimezoneOffset = getTimezoneOffset;
//# sourceMappingURL=get-timezone-offset.cjs.map
